import { Flex, Text } from '@chakra-ui/react';
import { useAdjudicationData } from 'src/contexts/AdjudicationDataProvider';
import ReviewDetailsCard from './ReviewDetailsCard';

const ReviewTab = () => {
  const { adjudicationReviews } = useAdjudicationData();

  return (
    <Flex flexDirection="column" gap={8}>
      <Text textStyle="headingTitle">Reviews</Text>
      <Flex gap={4} direction={'column'}>
        {adjudicationReviews?.map((data, index) => (
          <ReviewDetailsCard key={data.id} data={data} index={index} />
        ))}
      </Flex>
    </Flex>
  );
};

export default ReviewTab;
